"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridV4FuturesHedgeGridShareProcessor = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const TradeAPILib_1 = require("TradeAPILib");
const lodash_1 = require("lodash");
const tools_1 = require("../../CommonUtils/tools");
/**
 * 全仓网格分享相关函数
 */
var GridV4FuturesHedgeGridShareProcessor;
(function (GridV4FuturesHedgeGridShareProcessor) {
    /**
     * 把跟单的原订单数据转为新订单数据
     */
    function followOrderToNewOrder({ exchangeOrder, currentPrice, clearQuoteInvestment, }) {
        if (!(exchangeOrder === null || exchangeOrder === void 0 ? void 0 : exchangeOrder.exchangeGridV4FuturesHedgeGridOrder)) {
            return;
        }
        const _innerOrder = exchangeOrder.exchangeGridV4FuturesHedgeGridOrder;
        /** 子订单数据转换 */
        const fmtTrendOrder = (trendOrder) => {
            if (!trendOrder) {
                return;
            }
            const order = {
                base: exchangeOrder.base,
                quote: exchangeOrder.quote,
                grid_type: trendOrder.gridType,
                row: trendOrder.number,
                top: (0, tools_1.safeFormatNumToStr)(trendOrder.high),
                bottom: (0, tools_1.safeFormatNumToStr)(trendOrder.low),
                quote_investment: clearQuoteInvestment ? "" : trendOrder.quote_investment,
                leverage: trendOrder.leverage,
            };
            // 触发价
            if (trendOrder.isConditionAndNotTriggered) {
                order.condition = !(0, lodash_1.isNil)(trendOrder.condition) ? `${trendOrder.condition}` : undefined;
                order.condition_direction = trendOrder.conditionDirection ? `${trendOrder.conditionDirection}` : undefined;
            }
            // 止盈止损
            if (trendOrder.trend === TradeAPILib_1.GridFuturesTrend.long) {
                if (trendOrder.profit_stop_type === TradeAPILib_1.GridStopType.price) {
                    if (trendOrder.profit_stop && new trade_utils_lib_1.SafeDecimal(trendOrder.profit_stop).gt(currentPrice)) {
                        order.profit_stop_delay = trendOrder.profit_stop_delay;
                        order.profit_stop_type = trendOrder.profit_stop_type;
                        order.profit_stop = trendOrder.profit_stop;
                    }
                }
                if (trendOrder.loss_stop_type === TradeAPILib_1.GridStopType.price) {
                    if (trendOrder.loss_stop && new trade_utils_lib_1.SafeDecimal(trendOrder.loss_stop).lt(currentPrice)) {
                        order.loss_stop_delay = trendOrder.loss_stop_delay;
                        order.loss_stop_type = trendOrder.loss_stop_type;
                        order.loss_stop = trendOrder.loss_stop;
                    }
                }
            }
            if (trendOrder.trend === TradeAPILib_1.GridFuturesTrend.short) {
                if (trendOrder.profit_stop_type === TradeAPILib_1.GridStopType.price) {
                    if (trendOrder.profit_stop && new trade_utils_lib_1.SafeDecimal(trendOrder.profit_stop).lt(currentPrice)) {
                        order.profit_stop_delay = trendOrder.profit_stop_delay;
                        order.profit_stop_type = trendOrder.profit_stop_type;
                        order.profit_stop = trendOrder.profit_stop;
                    }
                }
                if (trendOrder.loss_stop_type === TradeAPILib_1.GridStopType.price) {
                    if (trendOrder.loss_stop && new trade_utils_lib_1.SafeDecimal(trendOrder.loss_stop).gt(currentPrice)) {
                        order.loss_stop_delay = trendOrder.loss_stop_delay;
                        order.loss_stop_type = trendOrder.loss_stop_type;
                        order.loss_stop = trendOrder.loss_stop;
                    }
                }
            }
            return order;
        };
        const newOrderData = {
            long: fmtTrendOrder(_innerOrder.long),
            short: fmtTrendOrder(_innerOrder.short),
            extra_margin_amount: "",
            profit_stop_delay: _innerOrder.profit_stop_delay,
            profit_stop_type: _innerOrder.profit_stop_type,
            profit_stop: _innerOrder.profit_stop,
        };
        // 跟单的止损需要小于0
        if (_innerOrder.loss_stop && new trade_utils_lib_1.SafeDecimal(_innerOrder.loss_stop).lt(0)) {
            newOrderData.loss_stop_delay = _innerOrder.loss_stop_delay;
            newOrderData.loss_stop_type = _innerOrder.loss_stop_type;
            newOrderData.loss_stop = _innerOrder.loss_stop;
        }
        return newOrderData;
    }
    GridV4FuturesHedgeGridShareProcessor.followOrderToNewOrder = followOrderToNewOrder;
})(GridV4FuturesHedgeGridShareProcessor || (exports.GridV4FuturesHedgeGridShareProcessor = GridV4FuturesHedgeGridShareProcessor = {}));
